var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHorizontalScrolling(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233,
    height: 175,
    viewBox: "0 0 233 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2743_72)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -18,
    y: 30,
    width: 193,
    height: 113,
    rx: 4,
    fill: "#718095",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 30,
    width: 88,
    height: 113,
    rx: 4,
    fill: "#718095",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 37,
    width: 74,
    height: 99,
    rx: 4,
    fill: "#718095",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    x: -24,
    y: 37,
    width: 189,
    height: 99,
    rx: 4,
    fill: "#718095",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.223 83H32.7623C30.1005 83 30 84.1193 30 85.5C30 86.8807 30.1005 88 32.7623 88H125.223C127.885 88 128 86.8807 128 85.5C128 84.1193 127.885 83 125.223 83Z",
    fill: "#D1D5DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.442 76H54.5503C53.0564 76 53 77.1193 53 78.5C53 79.8807 53.0564 81 54.5503 81H106.442C107.935 81 108 79.8807 108 78.5C108 77.1193 107.935 76 106.442 76Z",
    fill: "#D1D5DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.223 83H219.762C217.1 83 217 84.1193 217 85.5C217 86.8807 217.1 88 219.762 88H312.223C314.885 88 315 86.8807 315 85.5C315 84.1193 314.885 83 312.223 83Z",
    fill: "#D1D5DB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2743_72"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 233,
    height: 175,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalScrolling);
export default __webpack_public_path__ + "static/media/horizontal-scrolling.d557dda89793c518b1b211ebc2f708f2.svg";
export { ForwardRef as ReactComponent };